/**
 * Touch label used in job rows (active / scheduled / history): the touch number plus,
 * once resolved, the touch name. Plain text — the touches page was removed, so there is
 * nothing to navigate to.
 *
 * The name is resolved via useTouches with an `id__among=[touchId]` filter (same
 * pattern as ActivistCard's touch-history resolver). TanStack caches & dedups by
 * query key, so several rows pointing at the same touch share one request, and a
 * single-id filter still hits the cache once warmed. While the name loads we render
 * just «№{touchId}».
 */

import { type Touch } from "@/api/client";
import { useTouches } from "@/api/hooks";

export function TouchLink({ touchId }: { touchId: number }) {
  const query = useTouches(
    { page: 1, pageSize: 1, filters: [{ field: "id", operator: "among", value: [touchId] }] },
    Number.isFinite(touchId),
  );
  const touch: Touch | undefined = query.data?.results.find((t) => t.id === touchId);
  const name = touch?.name?.trim();

  return (
    <span>
      <span className="font-mono text-[var(--text-muted)]">№{touchId}</span>
      {name ? <span className="font-medium text-foreground"> {name}</span> : null}
    </span>
  );
}
